import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

import { environment } from '../../environments/environment';

import {
  colorMappingCond,
  colorMappingTemp,
  colorMappingWarn,
  colorMappingWarnDanger,
} from './constants/constants';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RouteSituation {
  dtg: Moment;
  parameter: string;
}

export interface InfoDtgItem {
  dtg: string;
  item: number;
}

export interface StationSchema {
  overwriteStationName: string;
  stationId: string;
  stationSource: string;
  stationType: string;
}

export interface DetailInfo {
  dangerLevel: Array<InfoDtgItem>;
  dangerLevelTotal: InfoDtgItem;
  firstSlipperiness: InfoDtgItem;
  minBridgeTgma: InfoDtgItem;
  minRoadTgma: InfoDtgItem;
  mostFrequentSlipperyCondition: InfoDtgItem;
  worstBridgeCondition: InfoDtgItem;
  worstRoadCondition: InfoDtgItem;
  biggestExtendOfWorstBridgeCondition: InfoDtgItem;
  biggestExtendOfWorstRoadCondition: InfoDtgItem;
}

@Injectable({
  providedIn: 'root',
})
export class RouteFcstService {
  private http = inject(HttpClient);

  private url = environment.url.mapServerApi;
  private urlBff = environment.url.bff;

  // fix product outside season
  public testMode = signal(false);

  runTimes: string;
  runtTimesUTCFormat: any;
  checkTimeStart: Moment;
  checkTimeEnd: string;
  mapsCountMin = 0;
  mapsCountMax = 24;
  roadTypeNumbersSelected: Array<number> = [];

  public getRuntimeCheck(
    productId: number,
    routeId: number
  ): Observable<string> {
    const url =
      this.url +
      '/bff/road/runtime/' +
      productId.toString() +
      '?routeId=' +
      routeId.toString();
    return this.http.get(url, { responseType: 'text' }).pipe(
      map(data => {
        if (data) {
          const re = /\"/gi;
          return data.replace(re, '');
        }
      })
    );
  }

  public getRouteDetails(
    customerId: number,
    productId: number,
    runTime: string,
    selectedPoint
  ): Observable<DetailInfo> {
    if (productId === 3976) {
      // demo route
      customerId = 10003;
    }
    if (productId === 10429) {
      // demo route
      customerId = 10084;
    }
    const fullUrl =
      this.url +
      '/bff/road/summary?runtime=' +
      runTime +
      '&customerId=' +
      customerId +
      '&productId=' +
      productId +
      '&routeId=' +
      selectedPoint.id;

    return this.http.get<DetailInfo>(fullUrl);
  }

  getStationInfo(id: string): Observable<any> {
    const fullUrl = this.urlBff + '/station/search/id/' + id;
    return this.http.get(fullUrl).pipe(
      map(data => {
        return data;
      })
    );
  }

  getChartDetailsEopByLatLon(lat: number, lon: number): Observable<any> {
    const fullUrl = this.urlBff + '/eop2/' + lat + '/' + lon;
    return this.http.get(fullUrl);
  }

  public colorMappingCond(value: number, detailsToShow?: boolean): string {
    return colorMappingCond(value, detailsToShow);
  }

  public colorMappingTemp(value: number): string {
    return colorMappingTemp(value);
  }

  public colorMappingWarn(value: number): string {
    return colorMappingWarn(value);
  }

  public colorMappingWarnDanger(value: number): string {
    return colorMappingWarnDanger(value);
  }
}
